<p class="mb-3" style="font-size: 0.8rem; font-weight: 400">
  You have our 30-day money-back satisfaction guarantee.
</p>

<div
  *ngIf="summaryData.priceListLoaded"
  class="d-flex justify-content-center col-12">
  <div class="d-flex flex-column justify-content-center summary border">
    <div *ngIf="withTitle" class="xheader py-3 px-4 border-bottom">
      <h3 class="mb-0">
        Monthly Summary{{
          summaryData.summaryModifier ? ': ' + summaryData.summaryModifier : ''
        }}
      </h3>
    </div>
    <div class="py-3 px-4 text-nowrap">
      <table class="r-table fw-normal w-100">
        <tr *ngIf="summaryData.plusValetChecked">
          <th scope="row">
            Verblio Valet&nbsp;
            <ng-template #contentTypesPopover>
              <div [innerHtml]="'' | keepHtml"></div>
            </ng-template>
          </th>
          <td>{{ summaryData.valetFormattedValue }}</td>
        </tr>

        <tr *ngIf="summaryData.durationInMonths > 1">
          <th scope="row">
            {{ summaryData.discountApplied * 100 }}% Off
            {{
              summaryData.durationInMonths === 3
                ? '(Quarterly plan)'
                : '(Annual plan)'
            }}
          </th>
          <td>-{{ summaryData.discountsFormattedValue }}</td>
        </tr>

        <ng-container *ngIf="summaryData.hasCoupons">
          <tr *ngFor="let coupon of summaryData.usableCoupons">
            <th scope="row">{{ coupon.externalName }}</th>
            <td>-{{ currencyFormat(percentCouponDiscount(coupon)) }}</td>
          </tr>
        </ng-container>

        <tr>
          <th scope="row" class="total">Monthly Total:</th>
          <td class="total">{{ summaryData.totalFormattedValue }}</td>
        </tr>
      </table>
    </div>
    <div
      class="py-3 px-4 border-top"
      *ngIf="summaryData.customerId && summaryData.actionButton">
      <p class="mb-0">
        {{ summaryData.confirmationMessage1 }}
        <ng-template [ngIf]="summaryData.confirmationMessage2">
          <br />{{ summaryData.confirmationMessage2 }}
        </ng-template>
      </p>
    </div>
  </div>
</div>
